import { render, staticRenderFns } from "./UserUpdateDialogContact.vue?vue&type=template&id=61c8b2ca&scoped=true"
import script from "./UserUpdateDialogContact.vue?vue&type=script&lang=ts"
export * from "./UserUpdateDialogContact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c8b2ca",
  null
  
)

export default component.exports